var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-notifier"},_vm._l((_vm.toasts),function(toast){return _c('Toast',_vm._b({key:toast.id,on:{"close":function($event){return _vm.closeToast(toast.id)}}},'Toast',{ ...toast },false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }